import React, {
  memo,
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "./styles.scss";
import TabsComponent from "../../../components/Classroom/TabsComponent";
import { TabsList } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { setLinks, showLinks } from "../../../store/sidebar";
import OverallPerformance from "./OverallPerformance";
import {
  getMainScreenEndponts,
  getStudentEndPoints,
  MustIncludedSidebarItems,
} from "../../../constants/sidebar";
import {
  resetNavbarParams,
  setNavbarParams,
  setText,
} from "../../../store/navbar";
import {
  getSingalClassroomData,
  getClassroomByUserId,
} from "../../../utils/classrooms";
import ClassesAttended from "./ClassesAttended";
import TroubleSpots from "./TroubleSpots";
import Scores from "./Scores";
import Diagnostic from "./Diagnostic";
import {
  getUserInformation,
  getUserPermission,
  getUserRole,
} from "../../../store/userRole";
import { Button, Spinner } from "react-bootstrap"; // Assuming you're using Bootstrap
import generatePDF, { Resolution, Margin } from "react-to-pdf"; // Desktop PDF generator
import html2canvas from "html2canvas"; // Mobile: capture each report section individually
import jsPDF from "jspdf"; // Mobile: assemble captured sections into a multi-page PDF
import StyledSelectField from "../../../components/Classroom/StyledSelectField";
import MdOutlineWest from "../../../constants/icons/Md/MdOutlineWest";
import { extractModulesInMentionedOrder } from "../../../utils/validations";
import PDFReport from "./PDFReport";
import StudentReportDialog from "./StudentReportDialog";
import CooldownButton from "./CooldownButton";

const Performance = ({ isMobileView }) => {
  const { id, tabId, studentId } = useParams(); // studentId from URL
  const [modules, setModules] = useState([]);
  const roleOfTheUser = useSelector(getUserRole);

  const getCurrentTab = () => {
    if(roleOfTheUser !== 'Student') {
      const studentReportTab = localStorage.getItem('StudentReportTab')
      if(studentReportTab) {
        return studentReportTab
      }
    } else {
      if(tabId)
        return tabId
    }
    return "overall-performance"
  }
  const [activeTab, setActiveTab] = useState(getCurrentTab());
  const { id: classroomId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const fromClassroom = queryParams.get("fromClassroom") || location.state?.fromClassroom;
  const backTo = location.state?.backTo;
  const [createdBy, setCreatedBy] = useState("");
  const rolePermissions = useSelector(getUserPermission);
  const userInformation = useSelector(getUserInformation);
  const navigate = useNavigate();
  const storeDispatch = useDispatch();
  const [isStudentReport, setIsStudentReport] = useState(false);
  const [hasIeltsExams, setHasIeltsExams] = useState(-1);
  const [loading, setLoading] = useState(false); // Loading state for PDF generation
  const [dataLoading, setDataLoading] = useState(false);
  const [pdfError, setPdfError] = useState(null); // Surface generation failures (esp. iOS)
  const pdfRef = useRef(); // Reference for PDF generation
  const skipFirst = useRef(false);
  const skipClassFirst = useRef(false);

  // New state to store classrooms the user is enrolled in
  const [classroomsList, setClassroomsList] = useState([]);
  const [subjectsMap, setSubjectsMap] = useState({});
  const [selectedClassroom, setSelectedClassroom] = useState(null);


  // Store assessment data from OverallPerformance for PDF generation
  const [assessmentDataForPdf, setAssessmentDataForPdf] = useState([]);

  useEffect(()=>{
    if(roleOfTheUser !== 'Student' && skipFirst.current){
      localStorage.setItem('StudentReportTab', activeTab)
    } else {
      skipFirst.current = true
    }
  },[activeTab, roleOfTheUser])

  useEffect(()=>{
    if(roleOfTheUser !== 'Student' && selectedClassroom !== null && classroomsList.length > 1 && skipClassFirst.current){
      localStorage.setItem('StudentReportClassroom', selectedClassroom)
    } else {
      skipClassFirst.current = true
    }
  },[classroomsList, roleOfTheUser, selectedClassroom])

  const getClassroomDetails = async () => {
    try {
      const response = await getSingalClassroomData(classroomId);
      if (response?.data?.classRoom) {
        if (response?.data?.classRoom?.name) {
          setModules(response?.data?.classRoom?.modulesIncluded);
          setCreatedBy(response?.data?.classRoom?.createdBy);
          setHasIeltsExams(response?.data?.classRoom?.hasIeltsExams)
          const subjectMapList = {}
          response?.data?.classRoom?.course?.subjects?.forEach(subject => {
            subjectMapList[subject?._id] = subject?.name
          })
          setSubjectsMap(subjectMapList)
        }
      }
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
    }
  };

  // Fetch the classrooms the student is enrolled in
  const getStudentClassrooms = async () => {
    if (studentId) {
      try {
        const response = await getClassroomByUserId(studentId);

        if (response?.data?.classRooms) {
          const classroomOptions = response.data.classRooms?.map(
            (classroom) => ({
              value: classroom._id,
              label: classroom.name,
              hasIeltsExams: classroom.hasIeltsExams,
              subjects: classroom.course.subjects
            })
          );
          setClassroomsList(classroomOptions);
          const storedClassroom = localStorage.getItem('StudentReportClassroom')
          let preSelected = null
          preSelected = storedClassroom ? classroomOptions.find((c) => c.value === storedClassroom)?.value : null
          if(!preSelected) {
            preSelected = fromClassroom
              ? classroomOptions.find((c) => c.value === fromClassroom)?.value
              : null;
          }
          setHasIeltsExams(classroomOptions[0]?.hasIeltsExams ?? false)
          const subjectMapList = {}
          classroomOptions[0]?.subjects?.forEach(subject => {
            subjectMapList[subject?._id] = subject?.name
          })
          setSubjectsMap(subjectMapList)
          setSelectedClassroom(preSelected || classroomOptions[0]?.value || null);
        }
      } catch (error) {
        console.error("Error fetching student classrooms:", error.message);
      }
    }
  };

  useEffect(() => {
    if (roleOfTheUser === "Student" && classroomId) {
      getClassroomDetails();
    }
    if (studentId) {
      getStudentClassrooms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classroomId, studentId]);

  useEffect(() => {
    storeDispatch(setNavbarParams(`Performance Review`));
    storeDispatch(setText("Performance Review"));
    storeDispatch(resetNavbarParams());
    const targetClassroomId = classroomId ? classroomId : fromClassroom ? fromClassroom : ''
    const defaultItems = [
      ...getStudentEndPoints(
        targetClassroomId,
        roleOfTheUser,
        userInformation?._id === createdBy,
        rolePermissions
      ),
    ];
    const sidebarItems = defaultItems.filter(
      (item) =>
        modules.includes(item?.value) ||
        MustIncludedSidebarItems.includes(item?.value)
    );
    if (roleOfTheUser === "Student" || roleOfTheUser === "Watcher") {
      const indOfItem = sidebarItems?.findIndex(
        (item) => item.value === "Performance Review"
      );
      if (indOfItem !== -1) {
        sidebarItems[indOfItem].selected = true;
      }
      storeDispatch(
        setLinks(extractModulesInMentionedOrder(sidebarItems, modules))
      );
      storeDispatch(showLinks());
    } else {
      const mainEndpoints = getMainScreenEndponts(
        roleOfTheUser,
        rolePermissions
      );

      const indOfItem = mainEndpoints?.findIndex(
        (item) => item.value === "Users"
      );
      if (indOfItem !== -1) {
        mainEndpoints[indOfItem].selected = true;
      }
      storeDispatch(setLinks(mainEndpoints));
      storeDispatch(showLinks());
    }
  }, [
    classroomId,
    storeDispatch,
    modules,
    roleOfTheUser,
    userInformation?._id,
    createdBy,
    rolePermissions,
    fromClassroom
  ]);

  // Handle assessment data from OverallPerformance component
  const handleAssessmentDataChange = useCallback((assessmentData) => {
    setAssessmentDataForPdf(assessmentData);
  }, []);

  const componentsList = useMemo(
    () => ({
      "overall-performance": (
        <OverallPerformance
          classroomId={hasIeltsExams !== -1 ? selectedClassroom || id : ''}
          isMobileView={isMobileView}
          studentId={studentId}
          onAssessmentDataChange={handleAssessmentDataChange}
          hasIeltsExams={hasIeltsExams}
          subjectsMap={subjectsMap}
        />
      ),
      "classes-attended": (
        <ClassesAttended
          classroomId={selectedClassroom || id}
          studentId={studentId}
        />
      ),
      "trouble-spots": (
        <TroubleSpots
          classroomId={selectedClassroom || id}
          studentId={studentId}
        />
      ),
      scores: (
        <Scores
          classroomId={selectedClassroom || id}
          isMobileView={isMobileView}
          studentId={studentId}
        />
      ),
      diagnostic: (
        <Diagnostic
          classroomId={selectedClassroom || id}
          studentId={studentId}
        />
      ),
    }),
    [id, isMobileView, selectedClassroom, studentId, handleAssessmentDataChange, hasIeltsExams, subjectsMap]
  );

  // --- PDF generation effect ---
  // Desktop (isMobileView === false) keeps the original react-to-pdf
  // single-shot capture, which has always worked fine there.
  // Mobile (isMobileView === true) — specifically iOS, where both Safari and
  // Chrome run on WebKit/WKWebView — was returning black pages even after
  // scale/CSS tweaks to the single-shot capture. That points to WKWebView's
  // canvas memory budget being exceeded by one giant canvas for a report
  // this long. So on mobile we instead capture each top-level section of
  // PDFReport separately (each one is small enough to stay well within any
  // memory limit) and assemble them into a multi-page PDF with jsPDF.
  const generateMobilePDF = useCallback(async () => {
    const root = pdfRef.current;
    // PDFReport renders one wrapping div.pdf-report-container; capture its
    // direct children (header, info, summary cards, tables, footer, etc.)
    // as separate sections instead of the whole thing at once.
    const container = root?.querySelector(".pdf-report-container") || root;
    const sections = container
      ? Array.from(container.children).filter((node) => {
          const rect = node.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        })
      : [];

    if (!container || sections.length === 0) {
      throw new Error("PDF report content not found or not yet rendered.");
    }

    const pdf = new jsPDF({
      unit: "pt",
      format: "a4",
      orientation: "portrait",
    });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 24;
    const usableWidth = pageWidth - margin * 2;

    let cursorY = margin;
    let placedAnything = false;

    // Capture sections sequentially (not in parallel) so only one canvas
    // exists in memory at a time — important on memory-limited iOS WKWebView.
    for (const section of sections) {
      const canvas = await html2canvas(section, {
        scale: 1.5, // safe: each section is small on its own, unlike the whole report
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement("style");
          style.innerHTML = `
            * {
              box-shadow: none !important;
              text-shadow: none !important;
              filter: none !important;
              backdrop-filter: none !important;
              transform: none !important;
            }
          `;
          clonedDoc.head.appendChild(style);
        },
      });

      if (canvas.width === 0 || canvas.height === 0) continue;

      const imgData = canvas.toDataURL("image/jpeg", 0.9);
      const imgWidthPt = usableWidth;
      const imgHeightPt = (canvas.height * imgWidthPt) / canvas.width;

      // Start a new page if this section won't fit under the current cursor.
      if (placedAnything && cursorY + imgHeightPt > pageHeight - margin) {
        pdf.addPage();
        cursorY = margin;
      }

      // If a single section is taller than one full page (e.g. a long
      // table), place it anyway from the top of its own page rather than
      // failing — it will simply run past the bottom margin.
      pdf.addImage(imgData, "JPEG", margin, cursorY, imgWidthPt, imgHeightPt);
      cursorY += imgHeightPt + 10;
      placedAnything = true;
    }

    if (!placedAnything) {
      throw new Error("No report sections could be captured.");
    }

    pdf.save("student-performance-report.pdf");
  }, []);

  const generateDesktopPDF = useCallback(async () => {
    const el = pdfRef.current;
    const contentWidth = el?.scrollWidth || 800;
    const contentHeight = el?.scrollHeight || 0;
    const MAX_TOTAL_PIXELS = 3000000; // ~3 megapixels, conservative safety margin
    const rawArea = contentWidth * contentHeight;
    const safeScale =
      rawArea > 0 ? Math.min(1, Math.sqrt(MAX_TOTAL_PIXELS / rawArea)) : 1;

    await generatePDF(() => pdfRef.current, {
      resolution: Resolution.HIGH,
      filename: "student-performance-report.pdf",
      page: {
        margin: Margin.SMALL,
        format: "A4",
        orientation: "portrait",
      },
      canvas: {
        mimeType: "image/jpeg",
        qualityRatio: 0.9,
        scale: safeScale,
        useCORS: true,
        allowTaint: true,
        windowWidth: contentWidth,
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement("style");
          style.innerHTML = `
            * {
              box-shadow: none !important;
              text-shadow: none !important;
              filter: none !important;
              backdrop-filter: none !important;
              transform: none !important;
            }
          `;
          clonedDoc.head.appendChild(style);
        },
      },
    });
  }, []);

  useEffect(() => {
    let cancelled = false;

    const runGeneratePDF = async () => {
      try {
        // Wait for web fonts to finish loading (iOS can still be painting
        // fonts/layout when a fixed timeout fires).
        if (document?.fonts?.ready) {
          await document.fonts.ready;
        }
        // Give the browser one more paint cycle to settle the layout.
        await new Promise((resolve) => requestAnimationFrame(resolve));
        // Small extra buffer for any async chart/image rendering inside PDFReport.
        await new Promise((resolve) => setTimeout(resolve, 300));

        if (cancelled) return;

        if (isMobileView) {
          await generateMobilePDF();
        } else {
          await generateDesktopPDF();
        }
        setPdfError(null);
      } catch (error) {
        console.error("PDF generation failed:", error);
        setPdfError(
          "We couldn't generate the PDF on this device. Please try again, or use a different browser/device."
        );
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    if (loading && !dataLoading) {
      runGeneratePDF();
    }

    return () => {
      cancelled = true;
    };
  }, [loading, dataLoading, isMobileView, generateMobilePDF, generateDesktopPDF]);

  const handleDownload = async () => {
    setPdfError(null);
    setDataLoading(true);
    setLoading(true);
  };

  return (
    <div style={{ backgroundColor: "white", margin: "10px" }}>
      {roleOfTheUser !== "Student" && (
        <div
          className="user-management-back-button mx-3"
          onClick={() => {
            localStorage.removeItem('StudentReportTab')
            localStorage.removeItem('StudentReportClassroom')
            if (backTo) {
              navigate(backTo);
            } else if (fromClassroom && fromClassroom?.length) {
              navigate(`/myClassrooms/${fromClassroom}/students`);
            } else {
              navigate(`/users-management/manage-students`);
            }
          }}
          variant="light"
        >
          <MdOutlineWest size={24} />
          Back
        </div>
      )}
      {/* Classroom select field for students */}
      {studentId && (
        <div className="px-3">
          <StyledSelectField
            optionsList={classroomsList}
            value={selectedClassroom}
            onChange={(e) => {
              const selClass = classroomsList.find(classToMap => classToMap?.value === e.value)
              setHasIeltsExams(selClass?.hasIeltsExams)
              const subjectMapList = {}
              selClass?.subjects?.forEach(subject => {
                subjectMapList[subject?._id] = subject?.name
              })
              setSubjectsMap(subjectMapList)
              setSelectedClassroom(e.value)
            }}
            label="Select Classroom"
            placeholder="Select Classroom"
            disabled={roleOfTheUser === "Watcher"}
          />
        </div>
      )}

      {isStudentReport &&
        ((roleOfTheUser !== "Student" && studentId && classroomsList.length) ||
          (roleOfTheUser === "Student" && classroomId && userInformation)) && (
          <StudentReportDialog
            isOpen={isStudentReport}
            onClose={() => {
              setIsStudentReport(false);
            }}
            isMobileView={isMobileView}
            studentId={
              roleOfTheUser !== "Student" ? studentId : userInformation?._id
            }
            classroomId={
              roleOfTheUser !== "Student"
                ? classroomsList[0].value
                : classroomId
            }
          />
        )}

      {/* Download button */}
      <div className="flex align-items-center download-section gap-2">
        <>
          {process.env.REACT_APP_ENV === "development" && (
            <>
              {roleOfTheUser === "Student" ? (
                <>
                  <CooldownButton
                    onClickHandler={() => {
                      setIsStudentReport(true);
                    }}
                  />
                </>
              ) : (
                <>
                  <Button
                    className="styled-button-styles"
                    variant="outline-primary"
                    style={{
                      marginTop: "10px",
                    }}
                    onClick={() => {
                      setIsStudentReport(true);
                    }}
                    disabled={loading}
                  >
                    Generate Detailed Report
                  </Button>
                </>
              )}
            </>
          )}
        </>
        <Button
          onClick={handleDownload}
          disabled={loading}
          className="download-button responsive-download-btn"
        >
          <div className="download-content">
            {loading ? (
              <Spinner
                size="sm"
                animation="border"
                className="download-spinner"
              />
            ) : (
              <>
                <span>Download Performance Report</span>
              </>
            )}
          </div>
        </Button>
      </div>

      {pdfError && (
        <div className="px-3" style={{ color: "#c0392b", marginTop: "8px" }}>
          {pdfError}
        </div>
      )}

      <TabsComponent
        tabsList={TabsList}
        activeTab={activeTab}
        onTabChange={(tab) => {
          setActiveTab(tab);
          if (roleOfTheUser === "Student") {
            navigate(`/student/${id}/${tab}`);
          }
        }}
        isDisable={id === "create"}
      />
      {/* Render only the selected tab */}
      {(selectedClassroom || id) && componentsList[activeTab]}

      {/* Hidden container to render the new professional PDF report.
          NOTE: keep this positioned in-flow (e.g. position: absolute; top: 0;
          left: 0; opacity: 0; pointer-events: none; z-index: -1;) rather than
          pushed far off-screen (e.g. left: -9999px). iOS Safari can skip
          painting elements positioned extremely far outside the viewport,
          which causes html2canvas to capture a blank/black canvas. */}
      {loading && (
        <div
          ref={pdfRef}
          className={`pdf-report ${loading ? "generating" : ""}`}
        >
          <PDFReport
            classroomId={selectedClassroom || id}
            studentId={studentId}
            assessmentData={assessmentDataForPdf}
            hasIeltsExams={hasIeltsExams}
            setDataLoading={setDataLoading}
          />
        </div>
      )}
    </div>
  );
};

export default memo(Performance);